import { StoreActionType as Type } from '../../types';

const orderDetailsInitialState = {
  data: null,
  loading: true,
  error: null,
};

export const orderDetailsReducer: any = (state = orderDetailsInitialState, action:any) => {
  switch (action.type) {
    case Type.GET_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null, 
      };
    case Type.GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload, 
      };
    case Type.GET_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, 
      };
    default:
      return state; 
  }
};
